<style lang="stylus">
    .ed-dropdown
        position relative
        width 100%
        height 24px
        .ed-dropdown-text
            width 100%
            height 24px
            line-height 24px
            font-size 12px
            text-indent 10px
            border-radius 3px
            user-select none
            cursor pointer
            display flex
            align-items center
        .ed-dropdown-list
            width 100%
            overflow auto
            padding 5px 0
            background-color #fff
            box-shadow  0px 4px 12px 0px rgba(0, 0, 0, 0.08)
            border-radius 6px
            padding 6px
            li
                font-size 12px
                padding 5px
                padding-left 10px
                user-select none
                cursor pointer
                border-radius 6px
                color #222
                &:hover
                    background rgba(242, 244, 249, 0.60)
              .choosed-img
                display inline-block
                margin-right 8px
                width 16px
                height 16px
                margin-right 8px
              .role
                flex 1

    .dropdownfade-enter-active,
    .dropdownfade-leave-active
        transition opacity .3s
    .dropdownfade-enter
    .dropdownfade-leave-to
        opacity 0
</style>
<template>
    <div class="ed-dropdown" ref="dropbox">
        <p class="ed-dropdown-text" @click="clickItem">
            <span class="text-ellipsis" style="max-width: 90%; display: block">{{ $t(roleList[activeItem].label) }}</span>
            <Icon class="ios-arrow" type="ios-arrow-down" />
        </p>
        <transition name="dropdownfade">
            <ul class="ed-dropdown-list" v-show="showList">
                <li v-for="item in roleList" :key="item.id" :class="{ active: activeItem == item.id }" @click="clickItemList(item)">
                    <span class="choosed-img">
                        <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="activeItem == item.id" />
                    </span>
                    <span class="role text-ellipsis" :title="$t(item.label)">{{ $t(item.label) }}</span>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class DropDown extends Vue {
        @Prop()
        roleList;
        showList = false;
        activeItem = 0;

        closeItem(e) {
            let objTarget: any = this.$refs.dropbox;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.showList = false;
                document.removeEventListener("click", this.closeItem);
            }
        }
        clickItem() {
            if (this.showList) {
                this.showList = false;
                document.removeEventListener("click", this.closeItem);
                return;
            }
            this.showList = true;
            document.addEventListener("click", this.closeItem);
        }
        clickItemList(item) {
            this.activeItem = item.id;
            this.showList = false;
            this.$emit("changeRoleList", { role: item.role });
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "reader": "可查看",
    "editor": "可编辑",
    "manager": "可管理"
  },
  "en": {
    "reader": "Reader",
    "editor": "Editor",
    "manager": "Manager"
  },
  "jp": {
    "reader": "閲覧者",
    "editor": "編集者",
    "manager": "管理者"
  },
  "de": {
    "reader": "Leser",
    "editor": "Redakteuer",
    "manager": "Admin"
  },
  "fr": {
    "reader": "Lecteur",
    "editor": "Éditeur",
    "manager": "Directeur"
  },
  "es": {
    "reader": "Lector",
    "editor": "Editor",
    "manager": "Administrador"
  },
  "it": {
    "reader": "Lettore",
    "editor": "Redattore",
    "manager": "Gestore"
  },
  "pt": {
    "reader": "Leitor",
    "editor": "Editor",
    "manager": "Gerente"
  },
  "tw": {
    "reader": "閱讀者",
    "editor": "編輯者",
    "manager": "管理者"
  },
  "kr": {
    "reader": "조회자",
    "editor": "편집자",
    "manager": "관리자"
  },
  "id": {
    "reader": "Pembaca",
    "editor": "Editor",
    "manager": "Manajer"
  }
}
</i18n>
